export default function ProductSpecifications({ specifications }) {
  if (!specifications || !Array.isArray(specifications) || specifications.length === 0) {
    return (
      <div className="text-center py-6">
        <p className="text-muted-foreground">No specifications available</p>
      </div>
    );
  }

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {specifications.map((item, index) => (
        <div key={index} className="rounded-2xl bg-neutral-100/10 p-4">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-muted-foreground">
            {item.label}
          </p>
          <p className="mt-2 text-sm font-medium">{item.value}</p>
        </div>
      ))}
    </div>
  );
}
